// GDP per capita is expressed in international-$ at 2021 prices.
// OurWorldinData.org/co2-and-greenhouse-gas-emissions | CC BY

/**
 * Data for the year 2023. Countries with a missing value are removed from the data set.
 *
 * - name: country name
 * - code: code of the country
 * - co2_emission: Consumption-based emissions per capita (tonnes per person)
 * - gdpPerCapita: GDP per capita in international-$ at 2021 prices
 * - population: population of the country
 * - region: region of the country according to Our World in Data
 */
export const globalCo2GdpPopulation = [
  {
    name: 'Albania',
    code: 'ALB',
    co2_emission: 1.914176,
    gdpPerCapita: 20481.035,
    population: 2811660,
    region: 'Europe',
  },
  {
    name: 'Argentina',
    code: 'ARG',
    co2_emission: 4.0771327,
    gdpPerCapita: 27230.396,
    population: 45538402,
    region: 'South America',
  },
  {
    name: 'Armenia',
    code: 'ARM',
    co2_emission: 2.607138,
    gdpPerCapita: 19402.752,
    population: 2943398,
    region: 'Asia',
  },
  {
    name: 'Australia',
    code: 'AUS',
    co2_emission: 14.069397,
    gdpPerCapita: 60684.96,
    population: 26451126,
    region: 'Oceania',
  },
  {
    name: 'Austria',
    code: 'AUT',
    co2_emission: 8.375129,
    gdpPerCapita: 64536.297,
    population: 9130434,
    region: 'Europe',
  },
  {
    name: 'Azerbaijan',
    code: 'AZE',
    co2_emission: 3.9579039,
    gdpPerCapita: 21310.738,
    population: 10318209,
    region: 'Asia',
  },
  {
    name: 'Bahrain',
    code: 'BHR',
    co2_emission: 14.056256,
    gdpPerCapita: 57819.906,
    population: 1569674,
    region: 'Asia',
  },
  {
    name: 'Bangladesh',
    code: 'BGD',
    co2_emission: 0.97895855,
    gdpPerCapita: 8242.398,
    population: 171466986,
    region: 'Asia',
  },
  {
    name: 'Belarus',
    code: 'BLR',
    co2_emission: 6.8615737,
    gdpPerCapita: 27782.438,
    population: 9115679,
    region: 'Europe',
  },
  {
    name: 'Belgium',
    code: 'BEL',
    co2_emission: 16.78538,
    gdpPerCapita: 63095.402,
    population: 11712891,
    region: 'Europe',
  },
  {
    name: 'Benin',
    code: 'BEN',
    co2_emission: 0.5976721,
    gdpPerCapita: 3721.2126,
    population: 14111035,
    region: 'Africa',
  },
  {
    name: 'Bolivia',
    code: 'BOL',
    co2_emission: 2.0931137,
    gdpPerCapita: 11616.157,
    population: 12244161,
    region: 'South America',
  },
  {
    name: 'Botswana',
    code: 'BWA',
    co2_emission: 5.849806,
    gdpPerCapita: 18932.48,
    population: 2480242,
    region: 'Africa',
  },
  {
    name: 'Brazil',
    code: 'BRA',
    co2_emission: 2.2259502,
    gdpPerCapita: 19079.812,
    population: 211140731,
    region: 'South America',
  },
  {
    name: 'Brunei',
    code: 'BRN',
    co2_emission: 19.34018,
    gdpPerCapita: 76616.7,
    population: 458959,
    region: 'Asia',
  },
  {
    name: 'Bulgaria',
    code: 'BGR',
    co2_emission: 5.1958365,
    gdpPerCapita: 33073.816,
    population: 6795805,
    region: 'Europe',
  },
  {
    name: 'Burkina Faso',
    code: 'BFA',
    co2_emission: 0.2519438,
    gdpPerCapita: 2486.2068,
    population: 23025777,
    region: 'Africa',
  },
  {
    name: 'Cambodia',
    code: 'KHM',
    co2_emission: 2.241986,
    gdpPerCapita: 6695.292,
    population: 17423884,
    region: 'Asia',
  },
  {
    name: 'Cameroon',
    code: 'CMR',
    co2_emission: 0.36597958,
    gdpPerCapita: 4875.251,
    population: 28372690,
    region: 'Africa',
  },
  {
    name: 'Canada',
    code: 'CAN',
    co2_emission: 13.230393,
    gdpPerCapita: 57517.44,
    population: 39299098,
    region: 'North America',
  },
  {
    name: 'Chile',
    code: 'CHL',
    co2_emission: 4.4843225,
    gdpPerCapita: 29563.678,
    population: 19658833,
    region: 'South America',
  },
  {
    name: 'China',
    code: 'CHN',
    co2_emission: 7.6319,
    gdpPerCapita: 22687.076,
    population: 1422584930,
    region: 'Asia',
  },
  {
    name: 'Colombia',
    code: 'COL',
    co2_emission: 1.9966097,
    gdpPerCapita: 18382.998,
    population: 52321152,
    region: 'South America',
  },
  {
    name: 'Costa Rica',
    code: 'CRI',
    co2_emission: 2.8776224,
    gdpPerCapita: 25979.629,
    population: 5105526,
    region: 'North America',
  },
  {
    name: "Cote d'Ivoire",
    code: 'CIV',
    co2_emission: 0.5732141,
    gdpPerCapita: 6520.899,
    population: 31165653,
    region: 'Africa',
  },
  {
    name: 'Croatia',
    code: 'HRV',
    co2_emission: 6.0860047,
    gdpPerCapita: 41320.203,
    population: 3896023,
    region: 'Europe',
  },
  {
    name: 'Cyprus',
    code: 'CYP',
    co2_emission: 6.4122796,
    gdpPerCapita: 51453.727,
    population: 1344981,
    region: 'Europe',
  },
  {
    name: 'Czechia',
    code: 'CZE',
    co2_emission: 9.25329,
    gdpPerCapita: 47558.41,
    population: 10809722,
    region: 'Europe',
  },
  {
    name: 'Denmark',
    code: 'DNK',
    co2_emission: 8.317133,
    gdpPerCapita: 69379.22,
    population: 5948134,
    region: 'Europe',
  },
  {
    name: 'Dominican Republic',
    code: 'DOM',
    co2_emission: 3.5687382,
    gdpPerCapita: 23282.49,
    population: 11331269,
    region: 'North America',
  },
  {
    name: 'Ecuador',
    code: 'ECU',
    co2_emission: 2.7195482,
    gdpPerCapita: 14343.019,
    population: 17980079,
    region: 'South America',
  },
  {
    name: 'Egypt',
    code: 'EGY',
    co2_emission: 2.2126539,
    gdpPerCapita: 16691.387,
    population: 114535772,
    region: 'Africa',
  },
  {
    name: 'El Salvador',
    code: 'SLV',
    co2_emission: 1.7838347,
    gdpPerCapita: 11424.6455,
    population: 6309629,
    region: 'North America',
  },
  {
    name: 'Estonia',
    code: 'EST',
    co2_emission: 9.2050495,
    gdpPerCapita: 41288.617,
    population: 1367195,
    region: 'Europe',
  },
  {
    name: 'Ethiopia',
    code: 'ETH',
    co2_emission: 0.18063699,
    gdpPerCapita: 2757.9592,
    population: 128691695,
    region: 'Africa',
  },
  {
    name: 'Finland',
    code: 'FIN',
    co2_emission: 8.473571,
    gdpPerCapita: 56250.88,
    population: 5601185,
    region: 'Europe',
  },
  {
    name: 'France',
    code: 'FRA',
    co2_emission: 6.1314254,
    gdpPerCapita: 54296.723,
    population: 66438828,
    region: 'Europe',
  },
  {
    name: 'Georgia',
    code: 'GEO',
    co2_emission: 4.0357165,
    gdpPerCapita: 22590.53,
    population: 3807494,
    region: 'Asia',
  },
  {
    name: 'Germany',
    code: 'DEU',
    co2_emission: 9.089263,
    gdpPerCapita: 63039.37,
    population: 84548233,
    region: 'Europe',
  },
  {
    name: 'Ghana',
    code: 'GHA',
    co2_emission: 0.7805456,
    gdpPerCapita: 6808.5376,
    population: 33787916,
    region: 'Africa',
  },
  {
    name: 'Greece',
    code: 'GRC',
    co2_emission: 6.559717,
    gdpPerCapita: 36700.51,
    population: 10242910,
    region: 'Europe',
  },
  {
    name: 'Guatemala',
    code: 'GTM',
    co2_emission: 1.4041212,
    gdpPerCapita: 12384.948,
    population: 18124841,
    region: 'North America',
  },
  {
    name: 'Guinea',
    code: 'GIN',
    co2_emission: 0.4441798,
    gdpPerCapita: 3904.824,
    population: 14405469,
    region: 'Africa',
  },
  {
    name: 'Honduras',
    code: 'HND',
    co2_emission: 0.98247296,
    gdpPerCapita: 6467.88,
    population: 10644853,
    region: 'North America',
  },
  {
    name: 'Hong Kong',
    code: 'HKG',
    co2_emission: 19.369726,
    gdpPerCapita: 64434.56,
    population: 7442738,
    region: 'Asia',
  },
  {
    name: 'Hungary',
    code: 'HUN',
    co2_emission: 5.856399,
    gdpPerCapita: 40333.254,
    population: 9686465,
    region: 'Europe',
  },
  {
    name: 'India',
    code: 'IND',
    co2_emission: 1.7684926,
    gdpPerCapita: 9301.756,
    population: 1438069597,
    region: 'Asia',
  },
  {
    name: 'Indonesia',
    code: 'IDN',
    co2_emission: 2.589589,
    gdpPerCapita: 13889.975,
    population: 281190068,
    region: 'Asia',
  },
  {
    name: 'Iran',
    code: 'IRN',
    co2_emission: 7.3787613,
    gdpPerCapita: 17044.816,
    population: 90608708,
    region: 'Asia',
  },
  {
    name: 'Ireland',
    code: 'IRL',
    co2_emission: 7.8577633,
    gdpPerCapita: 117862.125,
    population: 5196629,
    region: 'Europe',
  },
  {
    name: 'Israel',
    code: 'ISR',
    co2_emission: 9.541581,
    gdpPerCapita: 47527.152,
    population: 9256311,
    region: 'Asia',
  },
  {
    name: 'Italy',
    code: 'ITA',
    co2_emission: 7.210283,
    gdpPerCapita: 52870.324,
    population: 59499452,
    region: 'Europe',
  },
  {
    name: 'Jamaica',
    code: 'JAM',
    co2_emission: 2.9348342,
    gdpPerCapita: 11398.8125,
    population: 2839785,
    region: 'North America',
  },
  {
    name: 'Japan',
    code: 'JPN',
    co2_emission: 9.184616,
    gdpPerCapita: 45858.66,
    population: 124370947,
    region: 'Asia',
  },
  {
    name: 'Jordan',
    code: 'JOR',
    co2_emission: 2.7813537,
    gdpPerCapita: 9381.3545,
    population: 11439220,
    region: 'Asia',
  },
  {
    name: 'Kazakhstan',
    code: 'KAZ',
    co2_emission: 10.460201,
    gdpPerCapita: 34703.234,
    population: 20330109,
    region: 'Asia',
  },
  {
    name: 'Kenya',
    code: 'KEN',
    co2_emission: 0.63210475,
    gdpPerCapita: 5691.825,
    population: 55339007,
    region: 'Africa',
  },
  {
    name: 'Kuwait',
    code: 'KWT',
    co2_emission: 25.2844,
    gdpPerCapita: 47777.402,
    population: 4838781,
    region: 'Asia',
  },
  {
    name: 'Kyrgyzstan',
    code: 'KGZ',
    co2_emission: 2.7133956,
    gdpPerCapita: 6575.7754,
    population: 7073523,
    region: 'Asia',
  },
  {
    name: 'Laos',
    code: 'LAO',
    co2_emission: 1.9341022,
    gdpPerCapita: 8372.156,
    population: 7665001,
    region: 'Asia',
  },
  {
    name: 'Latvia',
    code: 'LVA',
    co2_emission: 7.098309,
    gdpPerCapita: 37277.723,
    population: 1882399,
    region: 'Europe',
  },
  {
    name: 'Lithuania',
    code: 'LTU',
    co2_emission: 7.188658,
    gdpPerCapita: 46159.707,
    population: 2854104,
    region: 'Europe',
  },
  {
    name: 'Luxembourg',
    code: 'LUX',
    co2_emission: 11.023863,
    gdpPerCapita: 130048.92,
    population: 665101,
    region: 'Europe',
  },
  {
    name: 'Madagascar',
    code: 'MDG',
    co2_emission: 0.20577449,
    gdpPerCapita: 1629.4609,
    population: 31195937,
    region: 'Africa',
  },
  {
    name: 'Malawi',
    code: 'MWI',
    co2_emission: 0.15318492,
    gdpPerCapita: 1649.2987,
    population: 21104480,
    region: 'Africa',
  },
  {
    name: 'Malaysia',
    code: 'MYS',
    co2_emission: 8.156515,
    gdpPerCapita: 32857.668,
    population: 35126295,
    region: 'Asia',
  },
  {
    name: 'Malta',
    code: 'MLT',
    co2_emission: 26.824337,
    gdpPerCapita: 60418.395,
    population: 532964,
    region: 'Europe',
  },
  {
    name: 'Mauritius',
    code: 'MUS',
    co2_emission: 6.2133427,
    gdpPerCapita: 26635.012,
    population: 1273591,
    region: 'Africa',
  },
  {
    name: 'Mexico',
    code: 'MEX',
    co2_emission: 4.3546333,
    gdpPerCapita: 21917.248,
    population: 129739761,
    region: 'North America',
  },
  {
    name: 'Mongolia',
    code: 'MNG',
    co2_emission: 10.665892,
    gdpPerCapita: 16222.864,
    population: 3431938,
    region: 'Asia',
  },
  {
    name: 'Morocco',
    code: 'MAR',
    co2_emission: 1.8538543,
    gdpPerCapita: 8915.352,
    population: 37712516,
    region: 'Africa',
  },
  {
    name: 'Mozambique',
    code: 'MOZ',
    co2_emission: 0.42895666,
    gdpPerCapita: 1512.2764,
    population: 33635163,
    region: 'Africa',
  },
  {
    name: 'Namibia',
    code: 'NAM',
    co2_emission: 3.2552075,
    gdpPerCapita: 10137.673,
    population: 2963102,
    region: 'Africa',
  },
  {
    name: 'Nepal',
    code: 'NPL',
    co2_emission: 1.5921838,
    gdpPerCapita: 4861.2305,
    population: 29694614,
    region: 'Asia',
  },
  {
    name: 'Netherlands',
    code: 'NLD',
    co2_emission: 8.298915,
    gdpPerCapita: 70198.93,
    population: 18092526,
    region: 'Europe',
  },
  {
    name: 'New Zealand',
    code: 'NZL',
    co2_emission: 8.002548,
    gdpPerCapita: 49508.27,
    population: 5172837,
    region: 'Oceania',
  },
  {
    name: 'Nicaragua',
    code: 'NIC',
    co2_emission: 1.0512289,
    gdpPerCapita: 7496.5293,
    population: 6823619,
    region: 'North America',
  },
  {
    name: 'Nigeria',
    code: 'NGA',
    co2_emission: 0.584879,
    gdpPerCapita: 7843.8345,
    population: 227882949,
    region: 'Africa',
  },
  {
    name: 'Norway',
    code: 'NOR',
    co2_emission: 7.0608263,
    gdpPerCapita: 90085.44,
    population: 5519167,
    region: 'Europe',
  },
  {
    name: 'Oman',
    code: 'OMN',
    co2_emission: 16.509298,
    gdpPerCapita: 37793.617,
    population: 5049267,
    region: 'Asia',
  },
  {
    name: 'Pakistan',
    code: 'PAK',
    co2_emission: 0.88930076,
    gdpPerCapita: 5418.7695,
    population: 247504505,
    region: 'Asia',
  },
  {
    name: 'Panama',
    code: 'PAN',
    co2_emission: 4.3772473,
    gdpPerCapita: 35872.95,
    population: 4458758,
    region: 'North America',
  },
  {
    name: 'Paraguay',
    code: 'PRY',
    co2_emission: 1.9176887,
    gdpPerCapita: 15826.088,
    population: 6844150,
    region: 'South America',
  },
  {
    name: 'Peru',
    code: 'PER',
    co2_emission: 2.330705,
    gdpPerCapita: 15327.582,
    population: 33845616,
    region: 'South America',
  },
  {
    name: 'Philippines',
    code: 'PHL',
    co2_emission: 1.8416777,
    gdpPerCapita: 9898.533,
    population: 114891199,
    region: 'Asia',
  },
  {
    name: 'Poland',
    code: 'POL',
    co2_emission: 7.064904,
    gdpPerCapita: 43672.766,
    population: 38762847,
    region: 'Europe',
  },
  {
    name: 'Portugal',
    code: 'PRT',
    co2_emission: 4.5500045,
    gdpPerCapita: 41768.254,
    population: 10430735,
    region: 'Europe',
  },
  {
    name: 'Qatar',
    code: 'QAT',
    co2_emission: 27.601795,
    gdpPerCapita: 116563.99,
    population: 2979086,
    region: 'Asia',
  },
  {
    name: 'Romania',
    code: 'ROU',
    co2_emission: 4.092971,
    gdpPerCapita: 40116.855,
    population: 19118482,
    region: 'Europe',
  },
  {
    name: 'Russia',
    code: 'RUS',
    co2_emission: 9.667057,
    gdpPerCapita: 39887.34,
    population: 145440502,
    region: 'Europe',
  },
  {
    name: 'Rwanda',
    code: 'RWA',
    co2_emission: 0.25205046,
    gdpPerCapita: 3062.999,
    population: 13954473,
    region: 'Africa',
  },
  {
    name: 'Saudi Arabia',
    code: 'SAU',
    co2_emission: 19.663857,
    gdpPerCapita: 64481.844,
    population: 33264289,
    region: 'Asia',
  },
  {
    name: 'Senegal',
    code: 'SEN',
    co2_emission: 1.0528344,
    gdpPerCapita: 4304.7617,
    population: 18077573,
    region: 'Africa',
  },
  {
    name: 'Singapore',
    code: 'SGP',
    co2_emission: 32.289295,
    gdpPerCapita: 129555.24,
    population: 5789092,
    region: 'Asia',
  },
  {
    name: 'Slovakia',
    code: 'SVK',
    co2_emission: 6.349146,
    gdpPerCapita: 39518.223,
    population: 5518057,
    region: 'Europe',
  },
  {
    name: 'Slovenia',
    code: 'SVN',
    co2_emission: 9.316166,
    gdpPerCapita: 47977.426,
    population: 2118394,
    region: 'Europe',
  },
  {
    name: 'South Africa',
    code: 'ZAF',
    co2_emission: 5.1474295,
    gdpPerCapita: 13695.376,
    population: 63212386,
    region: 'Africa',
  },
  {
    name: 'South Korea',
    code: 'KOR',
    co2_emission: 13.698197,
    gdpPerCapita: 54029.344,
    population: 51748744,
    region: 'Asia',
  },
  {
    name: 'Spain',
    code: 'ESP',
    co2_emission: 5.439509,
    gdpPerCapita: 47322.594,
    population: 47911583,
    region: 'Europe',
  },
  {
    name: 'Sri Lanka',
    code: 'LKA',
    co2_emission: 2.021593,
    gdpPerCapita: 13024.94,
    population: 22971615,
    region: 'Asia',
  },
  {
    name: 'Sweden',
    code: 'SWE',
    co2_emission: 5.8495603,
    gdpPerCapita: 62662.766,
    population: 10551493,
    region: 'Europe',
  },
  {
    name: 'Switzerland',
    code: 'CHE',
    co2_emission: 13.339576,
    gdpPerCapita: 82295.3,
    population: 8870564,
    region: 'Europe',
  },
  {
    name: 'Tajikistan',
    code: 'TJK',
    co2_emission: 1.2532278,
    gdpPerCapita: 4472.324,
    population: 10389807,
    region: 'Asia',
  },
  {
    name: 'Tanzania',
    code: 'TZA',
    co2_emission: 0.3870976,
    gdpPerCapita: 3620.7935,
    population: 66617607,
    region: 'Africa',
  },
  {
    name: 'Thailand',
    code: 'THA',
    co2_emission: 4.2616014,
    gdpPerCapita: 21191.453,
    population: 71702436,
    region: 'Asia',
  },
  {
    name: 'Togo',
    code: 'TGO',
    co2_emission: 1.0514942,
    gdpPerCapita: 2842.2307,
    population: 8223853,
    region: 'Africa',
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TTO',
    co2_emission: 14.87219,
    gdpPerCapita: 31196.604,
    population: 1502938,
    region: 'North America',
  },
  {
    name: 'Tunisia',
    code: 'TUN',
    co2_emission: 2.473592,
    gdpPerCapita: 12650.962,
    population: 12200434,
    region: 'Africa',
  },
  {
    name: 'Turkey',
    code: 'TUR',
    co2_emission: 5.534867,
    gdpPerCapita: 35069.17,
    population: 87270502,
    region: 'Asia',
  },
  {
    name: 'Uganda',
    code: 'UGA',
    co2_emission: 0.18089284,
    gdpPerCapita: 2791.0557,
    population: 48656606,
    region: 'Africa',
  },
  {
    name: 'Ukraine',
    code: 'UKR',
    co2_emission: 4.4074507,
    gdpPerCapita: 15916.958,
    population: 37732833,
    region: 'Europe',
  },
  {
    name: 'United Arab Emirates',
    code: 'ARE',
    co2_emission: 23.31011,
    gdpPerCapita: 70239.85,
    population: 10642089,
    region: 'Asia',
  },
  {
    name: 'United Kingdom',
    code: 'GBR',
    co2_emission: 7.092003,
    gdpPerCapita: 52592.684,
    population: 68682965,
    region: 'Europe',
  },
  {
    name: 'United States',
    code: 'USA',
    co2_emission: 15.813734,
    gdpPerCapita: 74158.72,
    population: 343477330,
    region: 'North America',
  },
  {
    name: 'Uruguay',
    code: 'URY',
    co2_emission: 3.1822698,
    gdpPerCapita: 31059.254,
    population: 3388083,
    region: 'South America',
  },
  {
    name: 'Vietnam',
    code: 'VNM',
    co2_emission: 2.469179,
    gdpPerCapita: 13545.935,
    population: 100352189,
    region: 'Asia',
  },
  {
    name: 'Zambia',
    code: 'ZMB',
    co2_emission: 0.61306703,
    gdpPerCapita: 3673.4841,
    population: 20723967,
    region: 'Africa',
  },
  {
    name: 'Zimbabwe',
    code: 'ZWE',
    co2_emission: 0.93750024,
    gdpPerCapita: 5218.0225,
    population: 16340829,
    region: 'Africa',
  },
];
